export default {
	sec_10: {
		title: {
			one: 'Use of international ',
			two: 'standard wallets',
		},
		desc: {
			one: 'Secure, proprietary wallet.',
			two: 'We use a wallet developed with our own technology, not a third-party wallet provider.',
		},
		btn: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},
	sec_12: {
		title: {
			one: 'Security ',
			two: 'level 2 or higher,',
			three: 'meeting international standards',
		},
		desc: {
			one: "We've taken extra security precautions to",
			two: 'completely block hacking.',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'Private keys are not generated.',
			},
			desc: {
				one: 'Even if an administrator or database is hacked,',
				two: "it's difficult to hack because the private key isn't available.",
			},
		},
		two: {
			title: {
				one: 'Your wallet is like your safe.',
			},
			desc: {
				one: 'We at JP WORLD Pay are confident in their security, ',
				two: 'as we have developed our own wallet and implemented security measures to address hacking threats.',
			},
		},
	},
};
